// extracted by mini-css-extract-plugin
module.exports = {"Container":"LinkDeInteres_Container__2bp0i","LinkDeInteres":"LinkDeInteres_LinkDeInteres__2GkL9","Icon":"LinkDeInteres_Icon__2g58o","Label":"LinkDeInteres_Label__2NNO_"};